/** Chinese regulation requires the ICP record and a 工信部 link on pages served from the .cn domain. */
export function IcpFooter() {
  if (!window.location.hostname.endsWith(".cn")) return null;

  return (
    <footer className="px-6 py-6 text-center text-xs text-gray-500 space-y-1">
      <p>
        工信部网站:{" "}
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noreferrer"
          className="underline hover:text-gray-700"
        >
          beian.miit.gov.cn
        </a>
      </p>
      <p>ICP:沪ICP备2025115330号-8A</p>
      <p>Copyright © 上海腾蒂教育科技有限公司 2026.</p>
    </footer>
  );
}
